import apiFetch from '../apiFetch'

export default function (saleId, token, lastAccessDate) {
  return apiFetch({ endPoint: `Dossier/Sales/${saleId}/FleetApprove`, method: 'PUT', body: null, token: token, lastAccessDate })
}
